import React, { useEffect, useRef, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import AdminLayout from "../../layout/AdminLayout";
import {
  addCampaign,
  getCampaignById,
  updateCampaign,
} from "../../../api/campaigns.api";
import { errorMsg, success } from "../../../utils/notifications";
import Select from "react-select";
import { getAllCompanies } from "../../../api/companies.api";
import { useNavigate, useParams } from "react-router-dom";
import { baseURL } from "../../../api/api";
import { getRestaurantsWithScreens } from "../../../api/restaurants.api";
import { getVehiclesWithType } from "../../../api/vehicle.api";
import RestaurantDetailsModal from "../Resturants/RestaurantDetailsModal"; // Adjust path accordingly

const initialData = {
  name: "",
  video: "",
  startDate: "",
  endDate: "",
  numberOfScreens: "",
  numberOfWeeks: "",
  location: "",
  status: "",
  type: "",
  cost: "",
  paid: false,
  company: "",
  selectedRestaurants: [], // Store restaurant IDs
  selectedVehicles: [], // Store selected vehicle IDs
};

const vehicleTypes = [
  { value: "VTC", label: "VTC" },
  { value: "Uber", label: "Uber" },
  { value: "Yango", label: "Yango" },
  { value: "Taxi", label: "Taxi" },
  { value: "Bolt", label: "Bolt" },
];

const statusValues = ["Pending Approval", "Approved"];
const typeValues = ["restaurant", "vehicle"];
const locations = ["Paris, France", "Douala, Cameroon"];
function AddCompaigns() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [saveCampaignLoading, setSaveCampaignLoading] = useState(false);
  const [addCampaignsData, setAddCampaignsData] = useState({
    type: null,
    selectedRestaurants: [],
  });
  const [isProcessingCheckbox, setIsProcessingCheckbox] = useState(false);
  const [loading, setLoading] = useState(false);
  const [vehicles, setVehicles] = useState({});
  const [restaurants, setRestaurants] = useState([]);
  const [availableScreensByType, setAvailableScreensByType] = useState([]);
  const [selectedRestaurantId, setSelectedRestaurantId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [screensPerVehicleType, setScreensPerVehicleType] = useState({});
  const [addCompaniesData, setAddCompaniesData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [numberOfScreensAvailable, setNumberOfScreensAvailable] =
    useState(null);

  const [endDate, setEndDate] = useState("");
  const [totalCost, setTotalCost] = useState(0);
  const inputRef = useRef(null);

  function addWeeks(startDate, numberOfWeeks) {
    if (!startDate) {
      return "";
    }
    const date = new Date(startDate);
    date.setDate(date.getDate() + numberOfWeeks * 7 - 1);
    date.setHours(23, 59, 59);
    // Get year, month, and day components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    // Return the date in the desired format: YYYY-MM-DD
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    getAllCompanies()
      .then((res) => {
        setAddCompaniesData(res?.data?.companies);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    if (
      addCampaignsData.type?.value === "vehicle" &&
      addCampaignsData.location &&
      addCampaignsData.startDate &&
      addCampaignsData.numberOfWeeks
    ) {
      setLoading(true);
      getVehiclesWithType(
        addCampaignsData.location,
        addCampaignsData.startDate,
        addCampaignsData.numberOfWeeks
      )
        .then((res) => {
          setVehicles(res?.data?.vehicles || {}); // Ensure data structure matches expectations
          setAvailableScreensByType(res?.data?.availableScreensByType || {}); // Store screen data
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
          setLoading(false);
        });
    }
  }, [
    addCampaignsData.type,
    addCampaignsData.location,
    addCampaignsData.startDate,
    addCampaignsData.numberOfWeeks,
  ]); // Re-fetch when any relevant data changes

  useEffect(() => {
    if (addCampaignsData.type?.value === "restaurant") {
      const startDate = addCampaignsData.startDate;
      const numberOfWeeks = addCampaignsData.numberOfWeeks;

      if (!startDate || !numberOfWeeks) return; // Avoid API call if values are missing

      setLoading(true);
      getRestaurantsWithScreens(startDate, numberOfWeeks)
        .then((res) => {
          setRestaurants(res?.data || []);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching restaurants:", error);
          setLoading(false);
        });
    }
  }, [
    addCampaignsData.type,
    addCampaignsData.startDate,
    addCampaignsData.numberOfWeeks,
  ]);

  useEffect(() => {
    if (id) {
      getCampaignById(id)
        .then((res) => {
          const campaignData = res?.data;
          const formattedStartDate = campaignData?.startDate.split("T")[0];
          const selectedCompany = addCompaniesData?.find(
            (company) => company?._id === campaignData?.company?._id
          );
          const updatedCampaignData = {
            ...campaignData,
            startDate: formattedStartDate,
            company: selectedCompany
              ? { value: selectedCompany._id, label: selectedCompany.name }
              : null,
            status: campaignData?.status
              ? { value: campaignData.status, label: campaignData.status }
              : null,
            selectedRestaurants: campaignData?.selectedRestaurants || [], // Ensure selectedRestaurants is always an array
            type: campaignData?.type
              ? { value: campaignData.type, label: campaignData.type } // <-- FIXED THIS
              : null,
          };

          setAddCampaignsData(updatedCampaignData);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [id, addCompaniesData]);

  useEffect(() => {
    if (!addCampaignsData.startDate || !addCampaignsData.numberOfWeeks) {
      setEndDate(""); // Keep empty if data is missing
      return;
    }

    const startDate = addCampaignsData.startDate;
    const numberOfWeeks = Number(addCampaignsData.numberOfWeeks);

    const calculatedEndDate = addWeeks(startDate, numberOfWeeks); // Already returns formatted date

    setEndDate(calculatedEndDate); // Directly set formatted string
  }, [addCampaignsData.startDate, addCampaignsData.numberOfWeeks]);

  useEffect(() => {
    let calculatedCost = 0;

    const numberOfScreens = Number(addCampaignsData.numberOfScreens) || 0;
    const numberOfWeeks = Number(addCampaignsData.numberOfWeeks) || 0;

    if (addCampaignsData.type?.value === "restaurant") {
      // Restaurant cost: 75 per restaurant per week
      calculatedCost = numberOfScreens * numberOfWeeks * 75;
    } else if (addCampaignsData.type?.value === "vehicle") {
      // Vehicle cost calculation
      calculatedCost = (numberOfScreens / 10) * (numberOfWeeks * 75);
    }

    setTotalCost(calculatedCost);
  }, [
    addCampaignsData.type,
    addCampaignsData.numberOfScreens,
    addCampaignsData.numberOfWeeks,
  ]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    if (name === "numberOfScreens") {
      const newValue = parseInt(value, 10);
      if (newValue > numberOfScreensAvailable) {
        return;
      }
    }

    setAddCampaignsData({
      ...addCampaignsData,
      [name]: newValue,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const maxFileSize = 100 * 1024 * 1024; // 300MB in bytes

    // Check if file size exceeds 100MB
    if (file.size > maxFileSize) {
      setSelectedFile(null);
      errorMsg("Error", "Selected video exceeds 300MB file size limit.");
      return;
    }

    const video = document.createElement("video");
    video.onloadedmetadata = () => {
      const duration = video.duration;
      // Check if duration exceeds 20 seconds
      if (duration > 21) {
        setSelectedFile(null);
        errorMsg("Error", "Selected video exceeds 20.5 seconds duration.");
        return;
      }

      // Check video dimensions if type is "restaurant"
      if (
        addCampaignsData.type?.value === "restaurant" ||
        addCampaignsData.type?.value === "vehicle"
      ) {
        const width = video.videoWidth;
        const height = video.videoHeight;

        // Define max width and height for validation (adjust as needed)
        const maxWidth = 3840;
        const maxHeight = 2160;

        // Check if dimensions exceed limits
        if (width >= maxWidth || height >= maxHeight) {
          setSelectedFile(null);
          errorMsg(
            "Error",
            `Video dimensions exceed maximum allowed: ${maxWidth}x${maxHeight}.`
          );
          return;
        }

        // Validate orientation based on type
        const isPortrait = height > width; // True if portrait
        const isLandscape = width > height; // True if landscape

        if (addCampaignsData.type.value === "restaurant" && !isPortrait) {
          setSelectedFile(null);
          errorMsg("Error", "Please upload a portrait video.");
          return;
        }

        if (addCampaignsData.type.value === "vehicle" && !isLandscape) {
          setSelectedFile(null);
          errorMsg("Error", "Please upload a landscape video.");
          return;
        }
      }

      setSelectedFile(file);
    };

    // Set video source
    video.src = URL.createObjectURL(file);
  };
  useEffect(() => {
    if (!selectedFile) return;

    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      const width = video.videoWidth;
      const height = video.videoHeight;

      const isPortrait = height > width;
      const isLandscape = width > height;

      if (addCampaignsData.type?.value === "restaurant" && !isPortrait) {
        setSelectedFile(null);
        // errorMsg("Error", "Restaurant campaigns require a portrait video.");
      }

      if (addCampaignsData.type?.value === "vehicle" && !isLandscape) {
        setSelectedFile(null);
        // errorMsg("Error", "Vehicle campaigns require a landscape video.");
      }
    };

    video.src = URL.createObjectURL(selectedFile);
  }, [addCampaignsData.type, selectedFile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};

    if (!addCampaignsData.location) {
      errors.location = "Location is required.";
    }

    if (
      addCampaignsData?.type?.value === "restaurant" &&
      (!addCampaignsData.selectedRestaurants ||
        addCampaignsData.selectedRestaurants.length === 0)
    ) {
      errors.selectedRestaurants = "Please select at least one restaurant.";
    }

    if (
      addCampaignsData?.type?.value === "vehicle" &&
      (!addCampaignsData.selectedVehicles ||
        addCampaignsData.selectedVehicles.length === 0)
    ) {
      errors.selectedVehicles = "Please select at least one vehicle.";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    if (!selectedFile && !addCampaignsData?.video) {
      errorMsg("Error", "A video must be uploaded to proceed.");
      return;
    }

    setSaveCampaignLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", addCampaignsData.name);
      formData.append("video", selectedFile);
      formData.append("startDate", addCampaignsData.startDate);
      formData.append("endDate", endDate);

      formData.append("numberOfWeeks", addCampaignsData.numberOfWeeks);
      formData.append("location", addCampaignsData.location);
      formData.append("status", addCampaignsData?.status?.value);
      formData.append("type", addCampaignsData?.type?.value);
      formData.append("company", addCampaignsData?.company?.value);
      formData.append("totalCost", totalCost);
      formData.append("paid", addCampaignsData?.paid || false);

      // ✅ Add selected restaurant IDs as a JSON string
      formData.append(
        "selectedRestaurants",
        JSON.stringify(addCampaignsData.selectedRestaurants)
      );
      // Append the correct number of screens and selected vehicles in the formData
      formData.append(
        "numberOfScreens",
        addCampaignsData.numberOfScreensAvailable || 0 // Ensure a valid number
      );
      formData.append(
        "selectedVehicles",
        JSON.stringify(addCampaignsData.selectedVehicles)
      );

      if (id) {
        await updateCampaign(id, formData);
        success("Successful", "Campaign Updated Successfully");
      } else {
        await addCampaign(formData);
        success("Successful", "Campaign Added Successfully");
      }

      setSaveCampaignLoading(false);
      setAddCampaignsData(initialData);
      setSelectedFile(null);
      navigate("/campaigns");
    } catch (err) {
      errorMsg("Error", err?.message || err);
      setSaveCampaignLoading(false);
    }
  };
  const resetVideo = () => {
    setSelectedFile(null);
    setAddCampaignsData({ ...addCampaignsData, video: "" });
    inputRef.current.value = "";
  };

  const handleCheckboxChange = (restaurantId) => {
    setAddCampaignsData((prevData) => {
      const updatedSelection = prevData.selectedRestaurants.includes(
        restaurantId
      )
        ? prevData.selectedRestaurants.filter((id) => id !== restaurantId) // Remove if already selected
        : [...prevData.selectedRestaurants, restaurantId]; // Add if not selected

      return {
        ...prevData,
        selectedRestaurants: updatedSelection,
        numberOfScreensAvailable: updatedSelection.length, // ✅ Update available screens dynamically
        numberOfScreens:
          prevData.type?.value === "restaurant"
            ? updatedSelection.length
            : prevData.numberOfScreens, // ✅ Sync with restaurant selection
      };
    });
  };

  const handleRestaurantClick = (id) => {
    setSelectedRestaurantId(id); // Ensure we're setting the correct _id
    setIsModalOpen(true);
  };
  const handleCheckboxChangeForVehicle = async (vehicleType) => {
    if (isProcessingCheckbox) return; // Prevent multiple selections while processing

    setIsProcessingCheckbox(true); // Block further selections

    const isSelected =
      addCampaignsData.selectedVehicleTypes?.includes(vehicleType);
    let updatedSelectedTypes = [
      ...(addCampaignsData.selectedVehicleTypes || []),
    ];
    let updatedSelectedVehicles = new Set(
      addCampaignsData.selectedVehicles || []
    );
    let updatedScreensPerVehicleType = { ...screensPerVehicleType };

    if (isSelected) {
      // ✅ Unchecking: Remove vehicle type and associated vehicles
      updatedSelectedTypes = updatedSelectedTypes.filter(
        (type) => type !== vehicleType
      );

      updatedSelectedVehicles = new Set(
        [...updatedSelectedVehicles].filter(
          (vId) =>
            !addCampaignsData.selectedVehiclesData?.[vId] ||
            addCampaignsData.selectedVehiclesData[vId].type !== vehicleType
        )
      );

      delete updatedScreensPerVehicleType[vehicleType]; // Remove screen count
      updateTotalScreens(updatedScreensPerVehicleType);
    } else {
      // ✅ Checking: Add vehicle type and fetch vehicles
      updatedSelectedTypes.push(vehicleType);

      try {
        const res = await getVehiclesWithType({
          location:
            addCampaignsData.location?.location || addCampaignsData.location,
          startDate: addCampaignsData.startDate,
          numberOfWeeks: addCampaignsData.numberOfWeeks,
        });

        const vehicleData =
          res?.data?.availableScreensByType?.[vehicleType]?.vehicles || [];
        let availableVehicles = vehicleData.filter(
          (v) => v.availableScreens >= 1
        );

        let requiredScreens = addCampaignsData.numberOfScreens || 1;
        let finalSelectedVehicles = [];
        let screensAdded = 0;

        for (
          let i = 0;
          i < availableVehicles.length && screensAdded < requiredScreens;
          i++
        ) {
          finalSelectedVehicles.push(availableVehicles[i].vehicleId);
          screensAdded += 1;
        }

        console.log("🛠 Selected Vehicles After Update:", finalSelectedVehicles);

        updatedScreensPerVehicleType[vehicleType] = screensAdded; // ✅ Track screens per type

        // ✅ Remove old vehicles of this type before adding new ones
        updatedSelectedVehicles = new Set(
          [...updatedSelectedVehicles].filter(
            (vId) => !vehicleData.some((v) => v.vehicleId === vId)
          )
        );

        // ✅ Add only the selected vehicles
        finalSelectedVehicles.forEach((vId) =>
          updatedSelectedVehicles.add(vId)
        );

        updateTotalScreens(updatedScreensPerVehicleType);
      } catch (error) {
        console.error("❌ Error fetching vehicles:", error);
      }
    }

    // ✅ Update state safely
    setAddCampaignsData((prev) => ({
      ...prev,
      selectedVehicleTypes: updatedSelectedTypes,
      selectedVehicles: Array.from(updatedSelectedVehicles),
    }));

    // ✅ Ensure screens count updates properly
    setScreensPerVehicleType(updatedScreensPerVehicleType);
    if (updatedSelectedVehicles.size > 0) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        selectedVehicles: undefined, // Clear error when vehicles are selected
      }));
    }
    setIsProcessingCheckbox(false); // ✅ Allow next selection
  };

  const updateTotalScreens = (screensData) => {
    const totalScreens = Object.values(screensData).reduce(
      (sum, num) => sum + num,
      0
    );

    console.log("🔥 Total Screens Calculated: " + totalScreens);

    setAddCampaignsData((prev) => ({
      ...prev,
      numberOfScreensAvailable: totalScreens,
      numberOfScreens: totalScreens, // ✅ Ensure `numberOfScreens` is updated before sending
    }));
  };

  // ✅ Update Selected Vehicles and their Screens
  const updateSelectedVehicles = (vehicleType, requiredScreens) => {
    setAddCampaignsData((prevData) => {
      let availableVehicles =
        vehicles[vehicleType]?.filter((v) => v.availableScreens >= 1) || [];

      let finalSelectedVehicles = [];
      let screensAdded = 0;

      for (let i = 0; i < availableVehicles.length; i++) {
        if (screensAdded < requiredScreens) {
          finalSelectedVehicles.push(availableVehicles[i].vehicleId);
          screensAdded += 1; // ✅ Add only the required screens
        } else {
          break;
        }
      }

      console.log(
        `✅ Updated Selected Vehicles for ${vehicleType}:`,
        finalSelectedVehicles
      );

      // ✅ Remove old vehicles of the same type before adding new ones
      const updatedVehicles = prevData.selectedVehicles.filter(
        (vId) => !vehicles[vehicleType]?.some((v) => v.vehicleId === vId)
      );

      // ✅ Append only the newly selected vehicles
      updatedVehicles.push(...finalSelectedVehicles);

      // ✅ Update screen count properly
      const updatedScreensPerType = {
        ...screensPerVehicleType,
        [vehicleType]: screensAdded,
      };

      updateTotalScreens(updatedScreensPerType);

      return {
        ...prevData,
        selectedVehicles: updatedVehicles,
        numberOfScreensAvailable: screensAdded,
        numberOfScreens: updatedVehicles.length, // ✅ Ensure `numberOfScreens` is updated correctly
      };
    });
  };

  return (
    <>
      <AdminLayout title={id ? " Update Campaign" : "Add Campaign"}>
        <form onSubmit={handleSubmit} method="POST">
          <div className="gap-5 px-3 md:px-5 lg:px-5 py-0.5 md:py-1.5 lg:py-1.5  grid grid-cols-1 grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
            <div className="px-1 lg:px-5 md:px-5 lg:col-span-8 md:col-span-12 col-span-12">
              <div className="gap-4 py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                {/* Name field - half width on large screens, full on small */}
                <div className="lg:col-span-6 md:col-span-6 col-span-12">
                  <label
                    htmlFor="name"
                    className="block text-base font-semibold leading-6 text-gray-600"
                  >
                    Name
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter Name"
                      value={addCampaignsData?.name}
                      onChange={handleChange}
                      id="name"
                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellow sm:leading-6 focus:ring-transparent"
                      required
                    />
                  </div>
                </div>

                {/* Location field - half width on large screens, full on small */}
                <div className="lg:col-span-6 md:col-span-6 col-span-12">
                  <label
                    htmlFor="location"
                    className="block text-base font-semibold leading-6 text-gray-600"
                  >
                    Location
                  </label>
                  <div className="mt-2">
                    <Select
                      name="location"
                      id="location"
                      options={locations.map((location) => ({
                        value: location,
                        label: location,
                      }))}
                      value={
                        addCampaignsData?.location
                          ? {
                              value: addCampaignsData?.location,
                              label: addCampaignsData?.location,
                            }
                          : null
                      }
                      className={`basic-multi-select w-full ${
                        formErrors.location
                          ? "border border-red-500 rounded-md"
                          : ""
                      }`}
                      classNamePrefix="select-location"
                      onChange={(selectedOption) => {
                        setAddCampaignsData({
                          ...addCampaignsData,
                          location: selectedOption?.value,
                        });
                        setFormErrors((prev) => ({ ...prev, location: "" }));
                      }}
                    />
                    {formErrors.location && (
                      <p className="text-red-500 text-sm mt-1">
                        {formErrors.location}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="lg:col-span-6 md:col-span-12 sm:col-span-12 ">
                <label
                  htmlFor="company"
                  className="block text-base font-semibold leading-6 text-gray-600"
                >
                  Company
                </label>
                <div className="mt-2">
                  {id ? (
                    <input
                      type="text"
                      value={addCampaignsData?.company?.label || ""}
                      readOnly
                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellow sm:leading-6 focus:ring-transparent"
                    />
                  ) : (
                    <Select
                      id="company"
                      name="type"
                      options={addCompaniesData?.map((company) => ({
                        value: company?._id,
                        label: company?.name,
                      }))}
                      className="basic-multi-select"
                      classNamePrefix="select Type"
                      value={addCampaignsData?.company}
                      onChange={(selectedOption) => {
                        setAddCampaignsData({
                          ...addCampaignsData,
                          company: selectedOption,
                        });
                      }}
                      required
                    />
                  )}
                </div>
              </div>

              <div className="gap-4 py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                <div className="lg:col-span-4 md:col-span-12 col-span-12 ">
                  <label
                    htmlFor="date"
                    className="block text-base font-semibold leading-6 text-gray-600"
                  >
                    Start Date
                  </label>
                  <div className="mt-2">
                    <input
                      type="date"
                      name="startDate"
                      placeholder="Enter Date"
                      value={addCampaignsData?.startDate}
                      onChange={handleChange}
                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellow sm:leading-6 focus:ring-transparent"
                      required
                      min={new Date().toISOString().split("T")[0]} // Prevent past dates
                    />
                  </div>
                </div>
                <div className="lg:col-span-4 md:col-span-12 col-span-12 ">
                  <label
                    htmlFor="numberOfWeeks"
                    className="block text-base font-semibold leading-6 text-gray-600"
                  >
                    Number of Weeks
                  </label>
                  <div className="mt-2">
                    <input
                      type="number"
                      name="numberOfWeeks"
                      placeholder="Number of Weeks"
                      value={addCampaignsData?.numberOfWeeks}
                      onChange={handleChange}
                      min={1}
                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellow sm:leading-6 focus:ring-transparent"
                      required
                    />
                  </div>
                </div>
                <div className="lg:col-span-4 md:col-span-12 col-span-12 ">
                  <label
                    htmlFor="date"
                    className="block text-base font-semibold leading-6 text-gray-600"
                  >
                    End Date
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="endDate"
                      placeholder="End Date"
                      value={endDate}
                      readOnly
                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellow sm:leading-6 focus:ring-transparent"
                    />
                  </div>
                </div>
              </div>
              <div className="lg:col-span-6 md:col-span-6 col-span-12">
                <div className="gap-4 py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                  <div className="lg:col-span-6 md:col-span-12 sm:col-span-12 ">
                    <label
                      htmlFor="status"
                      className="block text-base font-semibold leading-6 text-gray-600"
                    >
                      Status
                    </label>
                    <div className="mt-2">
                      <Select
                        name="type"
                        id="status"
                        options={statusValues.map((status) => ({
                          value: status,
                          label: status,
                        }))}
                        value={addCampaignsData?.status}
                        className="basic-multi-select"
                        classNamePrefix="select Type"
                        onChange={(selectedOption) => {
                          setAddCampaignsData({
                            ...addCampaignsData,
                            status: selectedOption,
                          });
                        }}
                        required
                      />
                    </div>
                  </div>
                  <div className="lg:col-span-6 md:col-span-12 sm:col-span-12">
                    <label
                      htmlFor="type"
                      className="block text-base font-semibold leading-6 text-gray-600"
                    >
                      Type
                    </label>
                    <div className="mt-2">
                      <Select
                        name="type"
                        id="type"
                        options={typeValues.map((type) => ({
                          value: type,
                          label: type,
                        }))}
                        value={addCampaignsData?.type}
                        className="basic-multi-select"
                        classNamePrefix="select Type"
                        onChange={(selectedOption) => {
                          if (!id) {
                            // Allow changes only in Add mode
                            setAddCampaignsData({
                              ...addCampaignsData,
                              type: selectedOption,
                            });
                          }
                        }}
                        isDisabled={!!id} // Disable the field if editing (id exists)
                        required
                      />
                    </div>
                  </div>
                </div>

                {addCampaignsData.type?.value === "vehicle" &&
                addCampaignsData.startDate ? (
                  <div className="col-span-12 xl:col-span-6 lg:col-span-6 ms-auto">
                    <h2 className="text-lg font-semibold text-gray-700 mb-2">
                      Select Vehicle Types
                    </h2>
                    {loading ? (
                      <p>Loading vehicles...</p>
                    ) : (
                      <div
                        className={`border-gray-300 rounded-lg ${
                          id ? "opacity-50 pointer-events-none" : ""
                        }`}
                      >
                        {/* Scrollable container for mobile */}
                        <div className="relative overflow-x-auto shadow-sm sm:rounded-lg">
                          <div className="inline-block min-w-full align-middle">
                            <div className="overflow-hidden">
                              <table className="min-w-full divide-y divide-gray-200 md:min-w-[700px]">
                                <thead className="bg-gray-100">
                                  <tr>
                                    <th
                                      scope="col"
                                      className="px-3 py-3 text-center text-xs md:text-base font-medium  tracking-wider w-16"
                                    >
                                      Select
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-3 py-3 text-center text-xs md:text-base font-medium  tracking-wider"
                                    >
                                      Vehicle Type
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-3 py-3 text-center text-xs md:text-base font-medium   tracking-wider"
                                    >
                                      Total Vehicles
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-3 py-3 text-center text-xs md:text-base font-medium   tracking-wider"
                                    >
                                      Screens
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-3 py-3 text-center text-xs font-medium  md:text-base tracking-wider"
                                    >
                                      Screens to Run
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                  {vehicleTypes.map(({ value, label }) => {
                                    const totalScreens =
                                      availableScreensByType[value]
                                        ?.totalScreensAvailable || 0;
                                    const isDisabled =
                                      totalScreens === 0 || !!id;

                                    return (
                                      <tr
                                        key={value}
                                        className="hover:bg-gray-50"
                                      >
                                        <td className="px-3 py-3 whitespace-nowrap text-center">
                                          <input
                                            type="checkbox"
                                            checked={
                                              totalScreens > 0 &&
                                              addCampaignsData.selectedVehicleTypes?.includes(
                                                value
                                              )
                                            }
                                            onChange={() =>
                                              handleCheckboxChangeForVehicle(
                                                value
                                              )
                                            }
                                            disabled={
                                              isDisabled || isProcessingCheckbox
                                            }
                                            className="h-4 w-4 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500"
                                          />
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap md:text-base text-center text-sm ">
                                          {label}
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap md:text-base text-center text-sm ">
                                          {vehicles[value]?.length || 0}
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap md:text-base text-center text-sm ">
                                          {totalScreens}
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap text-center">
                                          {addCampaignsData.selectedVehicleTypes?.includes(
                                            value
                                          ) && totalScreens > 0 ? (
                                            <input
                                              type="number"
                                              min="1"
                                              max={totalScreens}
                                              value={
                                                screensPerVehicleType[value] ||
                                                1
                                              }
                                              onChange={(e) => {
                                                let newValue =
                                                  parseInt(
                                                    e.target.value,
                                                    10
                                                  ) || 1;
                                                if (newValue < 1) newValue = 1;
                                                if (newValue > totalScreens)
                                                  newValue = totalScreens;

                                                setScreensPerVehicleType(
                                                  (prev) => {
                                                    const updatedScreens = {
                                                      ...prev,
                                                      [value]: newValue,
                                                    };
                                                    updateTotalScreens(
                                                      updatedScreens
                                                    );
                                                    updateSelectedVehicles(
                                                      value,
                                                      newValue
                                                    );
                                                    return updatedScreens;
                                                  }
                                                );
                                              }}
                                              className="w-16 text-center border rounded py-1 px-2"
                                              disabled={!!id}
                                            />
                                          ) : null}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        {formErrors.selectedVehicles && (
                          <p className="mt-2 text-base text-red-600 text-center">
                            {formErrors.selectedVehicles}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                ) : null}

                {addCampaignsData.type?.value === "restaurant" &&
                  restaurants.length > 0 && (
                    <div className="col-span-12 xl:col-span-6 lg:col-span-6 ">
                      <h2 className="text-lg  font-semibold text-gray-700 mb-2 mt-2 ms-auto">
                        Select Restaurants
                      </h2>

                      {loading ? (
                        <p className="text-center ">Loading restaurants...</p>
                      ) : (
                        <div
                          className={`border-gray-300 rounded-lg ${
                            id ? "opacity-50 pointer-events-none" : ""
                          }`} // Disable table in edit mode
                        >
                          <table className="table-auto w-full border-collapse md:min-w-[700px]">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="border px-6 py-3 text-center w-16">
                                  Select
                                </th>
                                <th className="border px-6 py-3 text-center">
                                  Restaurant Name
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {restaurants.map((restaurant) => (
                                <tr
                                  key={restaurant._id}
                                  className={`hover:bg-gray-50 ${
                                    restaurant.disabled
                                      ? "opacity-50 cursor-not-allowed"
                                      : ""
                                  }`}
                                >
                                  <td className="border px-6 py-3">
                                    <input
                                      type="checkbox"
                                      checked={addCampaignsData.selectedRestaurants.includes(
                                        restaurant._id
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(restaurant._id)
                                      }
                                      disabled={id || restaurant.disabled} // Disable in edit mode
                                    />
                                  </td>
                                  <td
                                    className={`border px-6 py-3 text-lg cursor-pointer ${
                                      restaurant.disabled
                                        ? ""
                                        : "text-blue-500 hover:underline"
                                    }`}
                                    onClick={() =>
                                      !restaurant.disabled &&
                                      handleRestaurantClick(restaurant._id)
                                    }
                                  >
                                    {restaurant.name}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {formErrors.selectedRestaurants && (
                            <p className="mt-2 text-base text-red-600 text-center">
                              {formErrors.selectedRestaurants}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  )}
              </div>

              {/* Show message only when there are no restaurants */}
              {addCampaignsData.type?.value === "restaurant" &&
                !loading &&
                restaurants.length === 0 && (
                  <p className="text-center text-red-500 font-semibold mt-2">
                    No restaurant screens available for the selected values.
                  </p>
                )}
              {/* Render the Modal */}
              <RestaurantDetailsModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                restaurantId={selectedRestaurantId}
              />

              <div className="lg:col-span-6 md:col-span-12 sm:col-span-12 ">
                <div className="mt-7 px-4 flex items-center justify-between">
                  <div className="relative flex items-start">
                    <div className="flex h-6 items-center">
                      <input
                        id="paid"
                        aria-describedby="paid"
                        name="paid"
                        type="checkbox"
                        checked={addCampaignsData?.paid}
                        onChange={handleChange}
                        className="h-4 w-4 rounded border-gray-100 text-yellowColor focus:ring-yellowColor"
                      />
                    </div>
                    <div className="ml-3 text-base leading-6">
                      <label
                        htmlFor="paid"
                        className="font-medium text-gray-700"
                      >
                        Paid
                      </label>
                    </div>
                  </div>
                  <p className="text-right text-lg font-semibold leading-6 text-gray-600">
                    Total Cost:{" "}
                    <span className="text-lg text-gray-600">
                      € {isNaN(totalCost) ? "0.00" : totalCost.toFixed(2)}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-4 md:col-span-12 col-span-12">
              <div className="flex items-center justify-between">
                <label
                  htmlFor="companyLogo"
                  className="pl-2 block text-base font-semibold leading-6 text-gray-600"
                >
                  Add Video
                </label>
                <button
                  type="button"
                  className="flex justify-center rounded-md border border-gray-400 py-1 px-4 text-xs leading-6 text-gray-800 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow"
                  onClick={resetVideo}
                >
                  Reset Video
                </button>
              </div>
              <div className="mt-2">
                <label
                  htmlFor="video"
                  className="mx-auto border-2 border-dashed border-gray-300 h-72 w-full inset-0 flex items-center justify-center cursor-pointer"
                >
                  {id && addCampaignsData?.video ? (
                    <video
                      src={`${baseURL}/s3/images/${addCampaignsData?.video?.name}`}
                      alt="Selected"
                      className="h-full w-full object-cover"
                      controls
                    />
                  ) : selectedFile ? (
                    <video
                      src={URL.createObjectURL(selectedFile)}
                      alt="Selected"
                      className="h-full w-full object-cover"
                      controls
                    />
                  ) : (
                    <AiOutlinePlus className="text-gray-400 h-14 w-14 p-2" />
                  )}
                </label>
                <input
                  ref={inputRef}
                  type="file"
                  name="video"
                  id="video"
                  className="hidden"
                  accept="video/*"
                  onChange={handleFileChange}
                />
              </div>
              {addCampaignsData?.type?.value && (
                <p className="text-base text-red-500 mt-2">
                  Note: Please upload a{" "}
                  {addCampaignsData.type.value === "restaurant"
                    ? "portrait"
                    : "landscape"}{" "}
                  video.
                </p>
              )}
            </div>
          </div>
          <div className=" mt-10 border-t-2 border-gray-200 px-3 pt-3 flex items-center justify-end gap-4 ">
            <button
              type="submit"
              disabled={saveCampaignLoading}
              className="flex justify-center rounded-md bg-yellowColor py-1.5 px-12 text-sm font-medium leading-6 text-gray-800 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow"
            >
              {saveCampaignLoading ? "Loading..." : id ? " Update" : "Submit"}
            </button>
          </div>
        </form>
      </AdminLayout>
    </>
  );
}

export default AddCompaigns;
